{
  "journalAudit.action.organisation.payment_method_added": "Moyen de paiement ajouté",
  "journalAudit.action.organisation.payment_method_defaulted": "Moyen de paiement par défaut changé",
  "journalAudit.action.organisation.payment_method_removed": "Moyen de paiement retiré",
  "journalAudit.action.organisation.payment_method_session_opened": "Saisie d’un moyen de paiement ouverte",
  "journalAudit.action.organisation.payment_retried": "Paiement relancé",
  "journalAudit.action.organisation.plan_change_cancelled": "Changement de palier annulé",
  "journalAudit.action.organisation.plan_change_requested": "Changement de palier demandé",
  "journalAudit.action.organisation.plan_changed": "Palier changé",
  "journalAudit.action.organisation.subscription_cancellation_withdrawn": "Résiliation annulée",
  "journalAudit.action.organisation.subscription_cancelled": "Résiliation programmée",
  "journalAudit.action.organisation.usage_alerts_updated": "Avis de consommation réglés",
  "journalAudit.action.organisation.usage_exported": "Relevé de consommation exporté",
  "v9.abonnement.acces.acces_restreint_la_facturation_reste_ouverte": "Accès restreint : la facturation reste ouverte.",
  "v9.abonnement.acces.masque": "Accès complet.",
  "v9.abonnement.acces.suspendu_pour_impaye_seule_la_facturation_reste_ouverte": "Suspendu pour impayé : seule la facturation reste ouverte.",
  "v9.abonnement.acces.vide": "Aucune restriction d’accès.",
  "v9.abonnement.action.organisation.payment_retried": "Paiement relancé",
  "v9.abonnement.action.organisation.plan_change_cancelled": "Changement annulé",
  "v9.abonnement.action.organisation.plan_change_requested": "Changement demandé",
  "v9.abonnement.action.organisation.plan_changed": "Palier changé",
  "v9.abonnement.action.organisation.subscription_cancellation_withdrawn": "Résiliation annulée",
  "v9.abonnement.action.organisation.subscription_cancelled": "Résiliation programmée",
  "v9.abonnement.ajout.aucune_donnee": "Aucune donnée de paiement n’est saisie ni conservée dans DoIt.",
  "v9.abonnement.ajout.composant_pret": "Le composant du prestataire est prêt : saisissez-y votre moyen.",
  "v9.abonnement.ajout.deja_enregistre": "Moyen déjà enregistré.",
  "v9.abonnement.ajout.enregistrer": "Enregistrer le moyen",
  "v9.abonnement.ajout.mobile_money": "Mobile money : l’opérateur est choisi dans le composant ; les échéances se règlent par lien.",
  "v9.abonnement.ajout.mobile_money_autre": "Mobile money : choisissez ce type pour régler par votre opérateur ; les échéances se règlent par lien.",
  "v9.abonnement.ajout.nature": "Type de moyen",
  "v9.abonnement.ajout.par_defaut": "Définir comme moyen par défaut",
  "v9.abonnement.ajout.reference": "Référence de saisie",
  "v9.abonnement.ajout.succes": "Moyen enregistré.",
  "v9.abonnement.annonce.texte": "Changement de prix annoncé : {{prix}} à partir du {{le}} ; résiliez avant le {{avant}} pour l’éviter.",
  "v9.abonnement.annonce.vide": "Aucun changement de prix annoncé.",
  "v9.abonnement.annuler": "Annuler",
  "v9.abonnement.aucun_moyen": "Aucun moyen de paiement : ajoutez-en un d’abord.",
  "v9.abonnement.avis.choix.100": "À 100 %",
  "v9.abonnement.avis.choix.80": "À 80 %",
  "v9.abonnement.avis.choix.aucun": "Aucun avis",
  "v9.abonnement.avis.choix.personnalise": "Personnalisés",
  "v9.abonnement.avis.enregistre": "Avis enregistrés.",
  "v9.abonnement.avis.enregistrer": "Enregistrer les avis",
  "v9.abonnement.avis.liste": "Destinataires (identifiants, séparés par des virgules)",
  "v9.abonnement.avis.personnalises": "Seuils personnalisés (1 à 100, séparés par des virgules)",
  "v9.abonnement.avis.proprietaire_et_administrateurs": "Propriétaire et administrateurs",
  "v9.abonnement.avis.rien_a_enregistrer": "Rien à enregistrer.",
  "v9.abonnement.avis.seuils": "Seuils",
  "v9.abonnement.avis.seuils_invalides": "Seuils invalides : de 1 à 100.",
  "v9.abonnement.avis.titre": "Avis de consommation",
  "v9.abonnement.ce_qui_depasse": "Ce qui dépasse le palier cible",
  "v9.abonnement.changement.annule": "Changement annulé.",
  "v9.abonnement.changement.lien.autre": "Suivre le changement en cours",
  "v9.abonnement.changement.lien.descente": "Suivre : descente de palier",
  "v9.abonnement.changement.lien.migration": "Suivre : migration des abonnés",
  "v9.abonnement.changement.lien.montee": "Suivre : montée de palier",
  "v9.abonnement.changement.lien.periodicite": "Suivre : changement de périodicité",
  "v9.abonnement.changement.lien.resiliation": "Suivre : résiliation",
  "v9.abonnement.changement.lien.souscription_devis": "Suivre : souscription sur devis",
  "v9.abonnement.changement.lien.souscription_essai": "Suivre : souscription au palier essayé",
  "v9.abonnement.changement.reessai_envoye": "Nouvelle tentative envoyée.",
  "v9.abonnement.changement.resiliation_annulee": "Résiliation annulée.",
  "v9.abonnement.changer.comparer": "Comparer les paliers",
  "v9.abonnement.changer.sans_palier": "Choisissez d’abord un palier dans la comparaison des paliers.",
  "v9.abonnement.code.AUCUNE_RESILIATION_PROGRAMMEE": "Aucune résiliation n’est programmée.",
  "v9.abonnement.code.CHANGEMENT_DEJA_EN_COURS": "Un changement d’abonnement est déjà en cours.",
  "v9.abonnement.code.CHANGEMENT_NON_ANNULABLE": "Ce changement n’est plus annulable.",
  "v9.abonnement.code.CONFIRMATION_IDENTITE_ECHOUEE": "Le secret ne correspond pas.",
  "v9.abonnement.code.CONFIRMATION_IDENTITE_REQUISE": "Confirmez votre identité avant cette action.",
  "v9.abonnement.code.CONTEXTE_INCOMPLET": "Aucune organisation dans la session.",
  "v9.abonnement.code.DEJA_AU_PALIER_GRATUIT": "L’organisation est déjà au palier gratuit.",
  "v9.abonnement.code.DESCENTE_BLOQUEE_PAR_L_USAGE": "Votre usage dépasse les quotas du palier cible : réduisez-le avant de descendre.",
  "v9.abonnement.code.DROIT_NON_TENU": "Vous ne tenez pas le droit nécessaire.",
  "v9.abonnement.code.IDEMPOTENCY_CONFLICT": "Cette demande a déjà été envoyée avec d’autres valeurs.",
  "v9.abonnement.code.MOYEN_DE_PAIEMENT_REQUIS": "Ajoutez un moyen de paiement avant de monter de palier.",
  "v9.abonnement.code.MOYEN_DE_PAIEMENT_SEUL_REQUIS": "C’est votre seul moyen de paiement et votre abonnement exige un débit.",
  "v9.abonnement.code.PAIEMENT_REFUSE": "Le prestataire a refusé le paiement : rien n’a été changé.",
  "v9.abonnement.code.PLATFORM_ADMIN_REQUIRED": "Réservé à l’administration de la plateforme.",
  "v9.abonnement.code.PRESTATAIRE_INDISPONIBLE": "Le prestataire de paiement est indisponible : réessayez plus tard.",
  "v9.abonnement.code.PROPRIETAIRE_SEUL": "Réservé au propriétaire de l’organisation.",
  "v9.abonnement.code.RESILIATION_DEJA_PROGRAMMEE": "Une résiliation est déjà programmée.",
  "v9.abonnement.code.RESOURCE_UNAVAILABLE": "Introuvable.",
  "v9.abonnement.code.VALIDATION_ERROR": "Saisie invalide.",
  "v9.abonnement.code.VERSION_CONFLICT": "Modifié entre-temps : rechargez avant de réessayer.",
  "v9.abonnement.confirmer_changement": "Confirmer le changement",
  "v9.abonnement.credit.origine.avoir": "avoir",
  "v9.abonnement.credit.origine.geste_commercial": "geste commercial",
  "v9.abonnement.credit.texte": "Crédit disponible : {{montant}} ({{origine}}).",
  "v9.abonnement.credit.vide": "Aucun crédit disponible.",
  "v9.abonnement.ecran.dialogue-ajouter-moyen-paiement": "Ajouter un moyen de paiement",
  "v9.abonnement.ecran.dialogue-changer-palier": "Forcer le palier d’une organisation",
  "v9.abonnement.ecran.dialogue-changer-palier-organisation": "Changer de palier — confirmation",
  "v9.abonnement.ecran.dialogue-resilier-abonnement": "Résilier l’abonnement",
  "v9.abonnement.ecran.organisation-abonnement": "Abonnement, consommation et facturation",
  "v9.abonnement.ecran.organisation-abonnement-changement": "Suivi d’un changement d’abonnement",
  "v9.abonnement.ecran.organisation-abonnement-historique": "Historique de l’abonnement",
  "v9.abonnement.ecran.organisation-consommation": "Consommation détaillée de l’organisation",
  "v9.abonnement.ecran.organisation-moyens-paiement": "Moyens de paiement de l’organisation",
  "v9.abonnement.ecran.plateforme-organisation-consommation": "Fiche d’une organisation — consommation",
  "v9.abonnement.ecran.plateforme-organisation-palier": "Fiche d’une organisation — palier",
  "v9.abonnement.effet_le": "Effet le {{le}}.",
  "v9.abonnement.essai": "Essai du palier {{palier}} : {{jours}} jour(s) restant(s). Retour au Gratuit à la fin, sauf souscription.",
  "v9.abonnement.etat.chargement": "Chargement : {{quoi}}…",
  "v9.abonnement.etat.echec": "L’opération a échoué.",
  "v9.abonnement.etat.erreur": "Impossible de charger {{quoi}}.",
  "v9.abonnement.etat.refus": "Accès refusé.",
  "v9.abonnement.etat.vide": "Rien à afficher.",
  "v9.abonnement.etat_changement.abandonne": "Abandonné chez le prestataire.",
  "v9.abonnement.etat_changement.annule": "Annulé.",
  "v9.abonnement.etat_changement.effectif": "Effectif.",
  "v9.abonnement.etat_changement.en_attente_du_prestataire": "En attente du prestataire.",
  "v9.abonnement.etat_changement.paiement_refuse": "Paiement refusé.",
  "v9.abonnement.etat_changement.programme_a_l_echeance": "Programmé à l’échéance.",
  "v9.abonnement.etat_changement.resultat_inconnu_verification_en_cours": "Résultat inconnu : vérification auprès du prestataire en cours.",
  "v9.abonnement.exceptions.a_venir": "Les demandes d’exception arrivent avec le paquet v9-p04.",
  "v9.abonnement.export.erreur": "Export impossible.",
  "v9.abonnement.export.telecharge": "Relevé téléchargé.",
  "v9.abonnement.exporter": "Exporter le relevé (CSV)",
  "v9.abonnement.facture.aucune_au_palier_gratuit": "Aucune facture au palier gratuit.",
  "v9.abonnement.facture.estimee": "Prochaine facture estimée : {{montant}} le {{le}}.",
  "v9.abonnement.facture.vide": "Aucune facture à venir.",
  "v9.abonnement.geste.annuler_changement": "Annuler le changement programmé",
  "v9.abonnement.geste.annuler_resiliation": "Annuler la résiliation",
  "v9.abonnement.geste.changer": "Changer de palier",
  "v9.abonnement.geste.consommation": "Détail de la consommation",
  "v9.abonnement.geste.continuer_prestataire": "Continuer chez le prestataire",
  "v9.abonnement.geste.coordonnees": "Coordonnées de facturation",
  "v9.abonnement.geste.exception": "Demander une exception",
  "v9.abonnement.geste.factures": "Factures",
  "v9.abonnement.geste.historique": "Historique de l’abonnement",
  "v9.abonnement.geste.moyens": "Moyens de paiement",
  "v9.abonnement.geste.reessayer_paiement": "Réessayer le paiement",
  "v9.abonnement.geste.regler_impaye": "Régler la facture impayée",
  "v9.abonnement.geste.resilier": "Résilier",
  "v9.abonnement.geste.souscrire_essai": "Souscrire au palier essayé",
  "v9.abonnement.geste.voir_changement": "Voir le changement",
  "v9.abonnement.geste.voir_exception": "Voir la demande",
  "v9.abonnement.historique.de": "De",
  "v9.abonnement.historique.le": "Date",
  "v9.abonnement.historique.origine": "Origine",
  "v9.abonnement.historique.suivi": "Suivi",
  "v9.abonnement.historique.titre": "Changements de palier",
  "v9.abonnement.historique.vers": "Vers",
  "v9.abonnement.historique.vide": "Aucun changement de palier.",
  "v9.abonnement.historique_changement": "Historique du changement",
  "v9.abonnement.mobile.texte": "Échéance à régler par mobile money : {{montant}} le {{le}} (rappel le {{rappel}}).",
  "v9.abonnement.mobile.vide": "Aucune échéance par mobile money.",
  "v9.abonnement.mois": "Mois",
  "v9.abonnement.mois_invalide": "Mois attendu au format AAAA-MM.",
  "v9.abonnement.moyen_inutile": "Aucun moyen de paiement débité pour ce changement.",
  "v9.abonnement.moyen_utilise": "Moyen utilisé : {{moyen}}.",
  "v9.abonnement.moyens.ajouter": "Ajouter un moyen de paiement",
  "v9.abonnement.moyens.confirmer_retrait": "Retirer ce moyen ?",
  "v9.abonnement.moyens.defaut_ok": "Moyen par défaut modifié.",
  "v9.abonnement.moyens.definir_defaut": "Définir par défaut",
  "v9.abonnement.moyens.expire_bientot": "Expire bientôt ({{le}})",
  "v9.abonnement.moyens.nature.carte": "Carte",
  "v9.abonnement.moyens.nature.mobile_money": "Mobile money",
  "v9.abonnement.moyens.nature.prelevement": "Prélèvement",
  "v9.abonnement.moyens.par_defaut": "Par défaut",
  "v9.abonnement.moyens.reprendre_achat": "Reprendre l’achat",
  "v9.abonnement.moyens.retire": "Moyen retiré.",
  "v9.abonnement.moyens.retirer": "Retirer",
  "v9.abonnement.moyens.revenir_devis": "Revenir au devis",
  "v9.abonnement.moyens.revenir_facture": "Revenir à la facture",
  "v9.abonnement.moyens.saisie_chez_le_prestataire": "La saisie se fait chez le prestataire : DoIt ne conserve qu’une référence et un libellé masqué.",
  "v9.abonnement.moyens.titre": "Moyens de paiement",
  "v9.abonnement.moyens.vide": "Aucun moyen de paiement.",
  "v9.abonnement.nature.descente": "Descente de palier",
  "v9.abonnement.nature.migration": "Migration des abonnés",
  "v9.abonnement.nature.montee": "Montée de palier",
  "v9.abonnement.nature.periodicite": "Changement de périodicité",
  "v9.abonnement.nature.resiliation": "Résiliation",
  "v9.abonnement.nature.souscription_devis": "Souscription sur devis",
  "v9.abonnement.nature.souscription_essai": "Souscription au palier essayé",
  "v9.abonnement.origine.exception_accordee": "Exception accordée",
  "v9.abonnement.origine.force_par_la_plateforme": "Forcé par la plateforme",
  "v9.abonnement.origine.migration": "Migration des abonnés",
  "v9.abonnement.origine.palier_par_defaut": "Palier par défaut",
  "v9.abonnement.origine.par_le_proprietaire": "Choisi par le propriétaire",
  "v9.abonnement.paiement.a_jour": "Paiements à jour.",
  "v9.abonnement.paiement.acces_restreint": "Impayé : accès restreint.",
  "v9.abonnement.paiement.delai_de_grace": "Paiement en retard : délai de grâce en cours.",
  "v9.abonnement.paiement.descente_programmee": "Descente de palier programmée.",
  "v9.abonnement.paiement.resiliation_programmee": "Résiliation programmée.",
  "v9.abonnement.paiement.suspendu_pour_impaye": "Suspendu pour impayé.",
  "v9.abonnement.paiement.vide": "Aucun état de paiement.",
  "v9.abonnement.palier.enterprise": "Entreprise",
  "v9.abonnement.palier.free": "Gratuit",
  "v9.abonnement.palier.team": "Équipe",
  "v9.abonnement.periodicite.annuelle": "Annuelle",
  "v9.abonnement.periodicite.mensuelle": "Mensuelle",
  "v9.abonnement.plateforme.changer_palier": "Changer le palier",
  "v9.abonnement.plateforme.choisir": "Choisir…",
  "v9.abonnement.plateforme.confirmer": "Confirmer le changement",
  "v9.abonnement.plateforme.consequences": "Conséquences",
  "v9.abonnement.plateforme.consequences_apres": "Les conséquences sont décrites après le changement.",
  "v9.abonnement.plateforme.depassement": "Usage au-delà des nouvelles limites : {{liste}}.",
  "v9.abonnement.plateforme.facturation": "Effet sur la facturation : au prochain renouvellement.",
  "v9.abonnement.plateforme.force": "Palier changé.",
  "v9.abonnement.plateforme.libre_service_annule": "Le changement en libre-service ouvert a été annulé.",
  "v9.abonnement.plateforme.motif": "Motif",
  "v9.abonnement.plateforme.nouveau_palier": "Nouveau palier",
  "v9.abonnement.plateforme.palier_actuel": "Palier actuel : {{palier}}.",
  "v9.abonnement.plateforme.palier_et_motif": "Choisissez un palier et saisissez un motif.",
  "v9.abonnement.plateforme.quotas_reduits": "Quotas réduits : {{liste}}.",
  "v9.abonnement.premier_debit": "Premier débit à la fin de l’essai : {{montant}} le {{le}}.",
  "v9.abonnement.premier_debit_aucun": "Aucun débit avant la fin de l’essai.",
  "v9.abonnement.prochaine_echeance": "prochaine échéance le {{le}}",
  "v9.abonnement.projets.aucun_quota": "aucun quota posé",
  "v9.abonnement.projets.non_visible": "non visible pour ce profil",
  "v9.abonnement.projets.titre": "Consommation par projet",
  "v9.abonnement.projets.vide": "Aucun projet dans l’organisation.",
  "v9.abonnement.prorata": "Montant au prorata calculé par le prestataire : {{montant}}.",
  "v9.abonnement.prorata_aucun": "Aucun montant à régler maintenant.",
  "v9.abonnement.quoi.acces": "l’accès pendant un impayé",
  "v9.abonnement.quoi.annonces": "les annonces de prix",
  "v9.abonnement.quoi.apercu": "l’aperçu du changement",
  "v9.abonnement.quoi.avis": "les avis de consommation",
  "v9.abonnement.quoi.changement": "le changement",
  "v9.abonnement.quoi.composant": "le composant du prestataire",
  "v9.abonnement.quoi.credit": "le crédit",
  "v9.abonnement.quoi.facture": "la prochaine facture",
  "v9.abonnement.quoi.historique": "l’historique",
  "v9.abonnement.quoi.mobile": "l’échéance mobile money",
  "v9.abonnement.quoi.moyens": "les moyens de paiement",
  "v9.abonnement.quoi.paiement": "l’état du paiement",
  "v9.abonnement.quoi.palier": "le palier",
  "v9.abonnement.quoi.projets": "la consommation par projet",
  "v9.abonnement.quoi.quotas": "les quotas",
  "v9.abonnement.quoi.releve": "le relevé",
  "v9.abonnement.quotas.illimite": "illimité",
  "v9.abonnement.quotas.limite_atteinte": "Limite atteinte",
  "v9.abonnement.quotas.nominal": "Normal",
  "v9.abonnement.quotas.proche_de_la_limite": "Proche de la limite",
  "v9.abonnement.quotas.titre": "Quotas et consommation",
  "v9.abonnement.quotas.vide": "Aucun quota pour ce palier.",
  "v9.abonnement.raison.aucun_moyen": "Ajoutez d’abord un moyen de paiement.",
  "v9.abonnement.raison.changement_deja_en_cours": "Un changement est déjà en cours : suivez-le ou annulez-le d’abord.",
  "v9.abonnement.raison.deja_au_palier_gratuit": "Vous êtes déjà au palier gratuit.",
  "v9.abonnement.raison.deja_par_defaut": "Déjà le moyen par défaut.",
  "v9.abonnement.raison.enregistrer_d_abord": "Enregistrez d’abord le moyen.",
  "v9.abonnement.raison.exceptions_a_venir": "Les demandes d’exception arrivent avec le paquet v9-p04.",
  "v9.abonnement.raison.factures_a_venir": "Les factures et coordonnées arrivent avec la facturation (paquet v9-p03).",
  "v9.abonnement.raison.hors_achat": "Accessible depuis un changement de palier seulement.",
  "v9.abonnement.raison.hors_devis": "Accessible depuis un devis seulement.",
  "v9.abonnement.raison.hors_facture": "Accessible depuis une facture seulement.",
  "v9.abonnement.raison.non_annulable": "Ce changement n’est plus annulable.",
  "v9.abonnement.raison.prestataire_a_venir": "Le prestataire de paiement réel n’est pas encore raccordé.",
  "v9.abonnement.raison.reauthentification_requise": "Confirmez votre identité pour résilier.",
  "v9.abonnement.raison.resiliation_deja_programmee": "Une résiliation est déjà programmée.",
  "v9.abonnement.raison.saisie_incomplete": "Saisie incomplète chez le prestataire.",
  "v9.abonnement.raison.sans_changement": "Changement sans suivi (antérieur au libre-service).",
  "v9.abonnement.raison.seul_moyen_requis": "Seul moyen de paiement : votre abonnement exige un débit.",
  "v9.abonnement.raison.suppression_a_venir": "La suppression de l’organisation arrive avec le paquet v9-p05.",
  "v9.abonnement.rapprochement.ecart": "Écart signalé à la plateforme.",
  "v9.abonnement.rapprochement.non_rapproche": "Non rapproché.",
  "v9.abonnement.rapprochement.orphelin": "Événement sans opération connue.",
  "v9.abonnement.rapprochement.rapproche": "Rapproché.",
  "v9.abonnement.recap.descente": "Descente vers {{palier}} à l’échéance.",
  "v9.abonnement.recap.migration": "Migration vers {{palier}}.",
  "v9.abonnement.recap.montee": "Montée vers {{palier}} ({{periodicite}}).",
  "v9.abonnement.recap.periodicite": "Passage en périodicité {{periodicite}} pour {{palier}}.",
  "v9.abonnement.recap.resiliation": "Résiliation.",
  "v9.abonnement.recap.souscription_devis": "Souscription sur devis.",
  "v9.abonnement.recap.souscription_essai": "Souscription au palier essayé {{palier}}.",
  "v9.abonnement.reessayer": "Réessayer",
  "v9.abonnement.reference": "Référence du prestataire : {{reference}}",
  "v9.abonnement.reference_absente": "Aucune référence du prestataire.",
  "v9.abonnement.releve.jours": "Jours",
  "v9.abonnement.releve.max": "Maximum",
  "v9.abonnement.releve.metrique": "Mesure",
  "v9.abonnement.releve.quota": "Quota du palier",
  "v9.abonnement.releve.titre": "Relevé de {{mois}}",
  "v9.abonnement.releve.total": "Total",
  "v9.abonnement.releve.vide": "Aucune consommation ce mois-ci.",
  "v9.abonnement.resilier.ce_qui_se_passe": "La résiliation prend effet à l’échéance : vous revenez au palier gratuit ; ce qui le dépasse passe en lecture seule. Vous pouvez l’annuler jusque-là.",
  "v9.abonnement.resilier.confirmer": "Confirmer la résiliation",
  "v9.abonnement.resilier.depasse": "Ce qui dépasse le palier gratuit",
  "v9.abonnement.resilier.garder": "Garder mon abonnement",
  "v9.abonnement.resilier.raison": "Raison de la résiliation",
  "v9.abonnement.resilier.raison_facultative": "(facultative)",
  "v9.abonnement.resilier.raisons.autre": "Autre",
  "v9.abonnement.resilier.raisons.autre_outil": "Autre outil",
  "v9.abonnement.resilier.raisons.fonctionnalites": "Fonctionnalités manquantes",
  "v9.abonnement.resilier.raisons.projet_termine": "Projet terminé",
  "v9.abonnement.resilier.raisons.trop_cher": "Trop cher",
  "v9.abonnement.resilier.rien_ne_depasse": "Rien ne dépasse le palier gratuit.",
  "v9.abonnement.resilier.secret": "Mot de passe (confirmation d’identité)",
  "v9.abonnement.resilier.supprimer": "Supprimer plutôt l’organisation",
  "v9.abonnement.retour": "Retour à l’abonnement",
  "v9.abonnement.section.facturation": "Facturation",
  "v9.abonnement.section.palier": "Palier et consommation"
}
